import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Asset, AppraisalsDetailsModelForEquity } from "../../all_Interfaces";


interface InitialState {
    data: AppraisalsDetailsModelForEquity,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as AppraisalsDetailsModelForEquity,
    error: '',
    loading: false
}

const appraisalDetailsForUSAppraisalSlice = createSlice({
    name: "appraisalDetails",
    initialState,
    reducers: {
        updateAppraisalDetailsForUSAppraisal(state, action: PayloadAction<AppraisalsDetailsModelForEquity>) {
            state.data = action.payload;
        },
    },
});

export const { updateAppraisalDetailsForUSAppraisal } = appraisalDetailsForUSAppraisalSlice.actions;

export default appraisalDetailsForUSAppraisalSlice.reducer;